import { AutoFilterBreezeListComponent } from '@common/classes/auto-filter-list';
import { VesselVisitStatusCodes } from '@common/classes/codes';
import { VesselVisitPermissions } from '@common/classes/permissions';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { DialogService } from '@common/services/dialog.service';
import { SharedService } from '@common/services/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import { InvoiceListModalComponent } from '../invoice-list-modal/invoice-list-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/shared.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "@common/services/dialog.service";
import * as i5 from "@angular/common";
import * as i6 from "@angular/router";
import * as i7 from "@angular/forms";
import * as i8 from "@fortawesome/angular-fontawesome";
import * as i9 from "@progress/kendo-angular-grid";
import * as i10 from "@progress/kendo-angular-layout";
import * as i11 from "../../../common/components/action-bar/action-bar.component";
import * as i12 from "../../../common/components/app-control/app-control.component";
import * as i13 from "../../../common/components/app-form/app-form.component";
import * as i14 from "../../../common/components/content-header/content-header.component";
import * as i15 from "../../../common/components/app-grid/app-grid.component";
import * as i16 from "../../../common/components/app-control-container/app-control-container.component";
import * as i17 from "../../../common/components/flag-icon.component";
import * as i18 from "../../../common/components/check-icon.component";
import * as i19 from "../../../common/components/accordion-header.component";
import * as i20 from "@ngx-translate/core";
import * as i21 from "../../../common/pipes/codelist.pipe";
import * as i22 from "../../../common/pipes/pad.pipe";
function VesselVisitListComponent_ng_template_6_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r8.numberOfActiveFilters, ")");
  }
}
function VesselVisitListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-accordion-header", 11);
    i0.ɵɵlistener("panelChange", function VesselVisitListComponent_ng_template_6_Template_app_accordion_header_panelChange_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.handleFilterHighlighter(true));
    });
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, VesselVisitListComponent_ng_template_6_span_5_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("panel", panel_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(4, 3, "Filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.numberOfActiveFilters > 0);
  }
}
function VesselVisitListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-form", 14);
    i0.ɵɵlistener("submit", function VesselVisitListComponent_ng_template_7_Template_app_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      ctx_r12.search();
      return i0.ɵɵresetView(ctx_r12.onAutoFilterChange());
    });
    i0.ɵɵelementStart(1, "app-control-container", null, 15)(3, "div", 16)(4, "div", 17)(5, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.filter.voyageNumber = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 17)(8, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.filter.vesselName = $event);
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 17)(11, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.filter.iMONumber = $event);
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 17)(14, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.filter.statusId = $event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 17)(17, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.filter.portOfCallId = $event);
    });
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 17)(20, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_20_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.filter.berthId = $event);
    });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(22, "div", 16)(23, "div", 17)(24, "app-control", 24);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.filter.primaryAgent = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 17)(27, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.filter.primaryCallPurposeId = $event);
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 17)(30, "app-control", 26);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_30_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.filter.ataFrom = $event);
    });
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 27)(33, "app-control", 28);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.filter.ataTo = $event);
    });
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 27)(36, "app-control", 29);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.filter.atdFrom = $event);
    });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(38, "div", 27)(39, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_39_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.filter.atdTo = $event);
    });
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(41, "div", 16)(42, "div", 27)(43, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_43_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.filter.countryId = $event);
    });
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 27)(46, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_46_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.filter.internalInvoiceNumber = $event);
    });
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "div", 27)(49, "app-control", 33);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_49_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.filter.invoiceNumber = $event);
    });
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(51, "div", 17)(52, "app-control", 34);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_52_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.filter.lastPortOfCallId = $event);
    });
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(54, "div", 17)(55, "app-control", 35);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_55_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.filter.nextPortOfCallId = $event);
    });
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "div", 17)(58, "app-control", 36);
    i0.ɵɵlistener("ngModelChange", function VesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_58_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.filter.partiallyBilled = $event);
    });
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(60, "div", 37)(61, "div", 17)(62, "div", 38)(63, "button", 39);
    i0.ɵɵlistener("click", function VesselVisitListComponent_ng_template_7_Template_button_click_63_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.clearFilter());
    });
    i0.ɵɵelement(64, "fa-icon", 40);
    i0.ɵɵtext(65, " \u00A0 ");
    i0.ɵɵelementStart(66, "span", 41);
    i0.ɵɵtext(67);
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(69, "button", 42);
    i0.ɵɵlistener("click", function VesselVisitListComponent_ng_template_7_Template_button_click_69_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.search());
    });
    i0.ɵɵelement(70, "fa-icon", 43);
    i0.ɵɵtext(71, " \u00A0 ");
    i0.ɵɵelementStart(72, "span", 41);
    i0.ɵɵtext(73);
    i0.ɵɵpipe(74, "translate");
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(6, 59, "MSW Visit Number"))("ngModel", ctx_r1.filter.voyageNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(9, 61, "Vessel Name"))("fetch", ctx_r1.fetchAllVesselNames)("fetchOnOpen", true)("ngModel", ctx_r1.filter.vesselName)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(12, 63, "IMO Number"))("ngModel", ctx_r1.filter.iMONumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(15, 65, "Visit State In Billing"))("ngModel", ctx_r1.filter.statusId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(18, 67, "Port Of Call"))("ngModel", ctx_r1.filter.portOfCallId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 69, "Berth"))("ngModel", ctx_r1.filter.berthId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(25, 71, "Primary Agent"))("ngModel", ctx_r1.filter.primaryAgent)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(28, 73, "Primary Purpose Of Call"))("ngModel", ctx_r1.filter.primaryCallPurposeId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(31, 75, "ATA From"))("ngModel", ctx_r1.filter.ataFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(34, 77, "ATA To"))("ngModel", ctx_r1.filter.ataTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(37, 79, "ATD From"))("ngModel", ctx_r1.filter.atdFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(40, 81, "ATD To"))("ngModel", ctx_r1.filter.atdTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(44, 83, "Flag"))("ngModel", ctx_r1.filter.countryId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(47, 85, "Internal Invoice Number"))("min", 1)("ngModel", ctx_r1.filter.internalInvoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(50, 87, "Invoice Number"))("ngModel", ctx_r1.filter.invoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(53, 89, "Last Port"))("ngModel", ctx_r1.filter.lastPortOfCallId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(56, 91, "Next Port"))("ngModel", ctx_r1.filter.nextPortOfCallId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(59, 93, "Partially Billed"))("ngModel", ctx_r1.filter.partiallyBilled)("entity", ctx_r1.filter);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(68, 95, "Clear"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(74, 97, "Search"));
  }
}
function VesselVisitListComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function VesselVisitListComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VesselVisitListComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 44);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
function VesselVisitListComponent_ng_template_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function VesselVisitListComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VesselVisitListComponent_ng_template_15_ng_container_0_Template, 1, 0, "ng-container", 44);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
const _c0 = function (a1) {
  return ["/vessel-visit/view/", a1];
};
function VesselVisitListComponent_ng_template_16_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 65);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r47 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, row_r47.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r47.voyageNumber, " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r48 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r48.statusId, "VesselVisitStatus")), " ");
  }
}
const _c1 = function (a1) {
  return ["/code-list/vessel/view/", a1];
};
function VesselVisitListComponent_ng_template_16_ng_template_12_app_flag_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-flag-icon", 67)(1, "a", 65);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r49 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("code", row_r49.vesselRevision.countryId)("tooltip", true)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(5, _c1, row_r49.vesselRevision.vesselId));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r49.vesselRevision.name, " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VesselVisitListComponent_ng_template_16_ng_template_12_app_flag_icon_0_Template, 3, 7, "app-flag-icon", 66);
  }
  if (rf & 2) {
    const row_r49 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", row_r49 == null ? null : row_r49.vesselRevision);
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 68);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r52 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r52.portOfCallId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r52.portOfCallId, "Port")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r53 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r53.berthId, "Berth")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r54 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r54.primaryAgentId, "Agent")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r55 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r55.primaryCallPurposeId, "CallPurpose")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 68);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r56 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r56.lastPortOfCallId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r56.lastPortOfCallId, "Port")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 68);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r57 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r57.nextPortOfCallId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r57.nextPortOfCallId, "Port")), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 69);
  }
  if (rf & 2) {
    const row_r58 = ctx.$implicit;
    i0.ɵɵproperty("check", row_r58.partiallyBilled)("hideFalse", true);
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_46_a_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 71);
    i0.ɵɵlistener("click", function VesselVisitListComponent_ng_template_16_ng_template_46_a_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r63);
      const row_r59 = i0.ɵɵnextContext().$implicit;
      const ctx_r61 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r61.openInvoicesModal(row_r59));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "pad");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r59 = i0.ɵɵnextContext().$implicit;
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r60.latestInvoice(row_r59)), " ");
  }
}
function VesselVisitListComponent_ng_template_16_ng_template_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VesselVisitListComponent_ng_template_16_ng_template_46_a_0_Template, 3, 3, "a", 70);
  }
  if (rf & 2) {
    const row_r59 = ctx.$implicit;
    const ctx_r46 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r46.latestInvoice(row_r59));
  }
}
const _c2 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
function VesselVisitListComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-grid", 45);
    i0.ɵɵlistener("selectionChange", function VesselVisitListComponent_ng_template_16_Template_app_grid_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r65 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r65.selection = $event);
    })("sortChange", function VesselVisitListComponent_ng_template_16_Template_app_grid_sortChange_0_listener($event) {
      i0.ɵɵrestoreView(_r66);
      const ctx_r67 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r67.onSortChange($event));
    });
    i0.ɵɵelement(1, "kendo-grid-checkbox-column", 46)(2, "kendo-grid-column", 47);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "kendo-grid-column", 48);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtemplate(6, VesselVisitListComponent_ng_template_16_ng_template_6_Template, 2, 4, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "kendo-grid-column", 50);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵtemplate(9, VesselVisitListComponent_ng_template_16_ng_template_9_Template, 3, 6, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "kendo-grid-column", 51);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, VesselVisitListComponent_ng_template_16_ng_template_12_Template, 1, 1, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "kendo-grid-column", 52);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelement(15, "kendo-grid-column", 53);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelement(17, "kendo-grid-column", 54);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelement(19, "kendo-grid-column", 55);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelement(21, "kendo-grid-column", 56);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementStart(23, "kendo-grid-column", 57);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵtemplate(25, VesselVisitListComponent_ng_template_16_ng_template_25_Template, 4, 8, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "kendo-grid-column", 58);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵtemplate(28, VesselVisitListComponent_ng_template_16_ng_template_28_Template, 3, 6, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "kendo-grid-column", 59);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵtemplate(31, VesselVisitListComponent_ng_template_16_ng_template_31_Template, 3, 6, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "kendo-grid-column", 60);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵtemplate(34, VesselVisitListComponent_ng_template_16_ng_template_34_Template, 3, 6, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "kendo-grid-column", 61);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵtemplate(37, VesselVisitListComponent_ng_template_16_ng_template_37_Template, 4, 8, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "kendo-grid-column", 62);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵtemplate(40, VesselVisitListComponent_ng_template_16_ng_template_40_Template, 4, 8, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "kendo-grid-column", 63);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵtemplate(43, VesselVisitListComponent_ng_template_16_ng_template_43_Template, 1, 2, "ng-template", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "kendo-grid-column", 64);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵtemplate(46, VesselVisitListComponent_ng_template_16_ng_template_46_Template, 1, 1, "ng-template", 49);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r6.query)("selectable", i0.ɵɵpureFunction0(60, _c2))("selectBy", "id")("sortable", true)("sort", ctx_r6.gridSort)("selection", ctx_r6.selection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("width", 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 26, "ID"));
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 28, "Visit Number"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 30, "Visit State In Billing"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 32, "Vessel Name"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(14, 34, "IMO Number"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(16, 36, "ATA"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(18, 38, "ATD"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(20, 40, "ETA"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(22, 42, "ETD"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(24, 44, "Port Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(27, 46, "Berth"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(30, 48, "Primary Agent"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(33, 50, "Primary Purpose Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(36, 52, "Last Port"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(39, 54, "Next Port"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(42, 56, "Partially Billed"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(45, 58, "Latest Invoice"));
    i0.ɵɵproperty("sortable", false);
  }
}
export class VesselVisitListComponent extends AutoFilterBreezeListComponent {
  constructor(breezeViewService, sharedService, modalService, dialogService) {
    super(breezeViewService, sharedService, modalService, dialogService);
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.modalService = modalService;
    this.dialogService = dialogService;
    this.queryName = 'VesselVisits';
    this.parentRoute = '/vessel-visit';
    this.excelExport = true;
    this.createPermission = VesselVisitPermissions.Action.create;
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('Vessel Visit List')
    }];
    this.gridSort = [{
      field: 'id',
      dir: 'desc'
    }];
    this.actionBar.push({
      label: this.translateService.instant('Workflow'),
      items: [{
        label: () => this.translateService.instant('Bill'),
        icon: 'file-invoice',
        isDisabled: () => this.everyVesselVisitMustBe(VesselVisitStatusCodes.Active),
        onClick: () => this.bill()
      }, {
        label: () => this.translateService.instant('Complete'),
        icon: 'clipboard-check',
        isDisabled: () => this.everyVesselVisitMustBe(VesselVisitStatusCodes.Billed),
        onClick: () => this.complete()
      }, {
        label: this.translateService.instant('Send To Archive'),
        icon: 'archive',
        isDisabled: () => this.everyVesselVisitMustBe(VesselVisitStatusCodes.Completed),
        onClick: () => this.archive()
      }]
    });
  }
  get selectionData() {
    const data = {};
    let vesselVisitsCount;
    if (_.isEmpty(this.selection)) {
      data.query = this.breezeService.convertToDto(this.filter);
      vesselVisitsCount = this.appGrid.internalData.total;
    } else {
      data.ids = this.selection;
      vesselVisitsCount = this.selection.length;
    }
    return {
      data,
      vesselVisitsCount
    };
  }
  getDefaultFilter(data) {
    return this.breezeViewService.entityManager.createEntity('GetVesselVisitsQuery', {
      archived: this.activeTab === 1,
      ...data
    });
  }
  complete() {
    super.executeAndHandle(this.queryName, 'CompleteVesselVisits', 'Complete');
  }
  bill() {
    super.executeAndHandle(this.queryName, 'BillVesselVisit', 'Bill');
  }
  archive() {
    super.executeAndHandle(this.queryName, 'ArchiveVesselVisits', 'Archive');
  }
  everyVesselVisitMustBe(status) {
    if (this.appGrid?.internalData?.data !== undefined && !_.isEmpty(this.selection)) {
      const {
        data
      } = this.appGrid.internalData;
      const {
        selection
      } = this;
      const selectionData = data.filter(el => selection.includes(el.id));
      return !selectionData.every(el => el.statusId === status);
    }
    return true;
  }
  latestInvoice(row) {
    var invoiceNumbers = row.invoices.map(invoice => invoice.invoiceNumber).filter(invoiceNumber => invoiceNumber);
    return invoiceNumbers.sort((a, b) => this.extractNumber(a) - this.extractNumber(b)).at(-1);
  }
  extractNumber(invoiceNumber) {
    return +invoiceNumber.split('-').at(-1).split('/').at(0);
  }
  openInvoicesModal(row) {
    const modalRef = this.breezeViewService.openModal(InvoiceListModalComponent, {
      size: 'xl'
    });
    modalRef.componentInstance.invoices = row.invoices;
  }
  exportGridToExcel() {
    super.queryAndTriggerSaveExcel();
  }
  onSortChange(sort) {
    this.gridSort = sort;
  }
}
VesselVisitListComponent.ɵfac = function VesselVisitListComponent_Factory(t) {
  return new (t || VesselVisitListComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.SharedService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.DialogService));
};
VesselVisitListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VesselVisitListComponent,
  selectors: [["app-vessel-visit-list"]],
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 18,
  vars: 13,
  consts: [[3, "items"], [3, "title", "breadcrumb"], [1, "filter-wrapper"], ["activeIds", "ngb-panel-0"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "mt-3", 3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], ["tabContent", ""], [3, "panel", "panelChange"], ["icon", "filter"], [4, "ngIf"], [3, "submit"], ["filterHighlighter", ""], [1, "row"], [1, "col"], ["property", "voyageNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "property", "vesselName", 3, "label", "fetch", "fetchOnOpen", "ngModel", "entity", "ngModelChange"], ["property", "iMONumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselVisitStatus", "property", "statusId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "portOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Agent", "property", "primaryAgent", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CallPurpose", "property", "primaryCallPurposeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "ataFrom", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-2"], ["type", "datetime", "property", "ataTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "atdFrom", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "atdTo", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "internalInvoiceNumber", 3, "label", "min", "ngModel", "entity", "ngModelChange"], ["property", "invoiceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "lastPortOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "nextPortOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "partiallyBilled", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "float-right"], [1, "btn", "btn-sm", "btn-danger", "mr-2", 3, "click"], ["icon", "trash", 1, "ml-1"], [1, "btn-text"], [1, "btn", "btn-sm", "btn-primary", 3, "click"], ["icon", "search", 1, "ml-1"], [4, "ngTemplateOutlet"], ["pagerPosition", "both", "entityName", "VesselVisit", "exportFileName", "VesselVisitListExport", 3, "data", "selectable", "selectBy", "sortable", "sort", "selection", "selectionChange", "sortChange"], ["showSelectAll", "true", 3, "width"], ["field", "id", 3, "title", "hidden"], ["field", "voyageNumber", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "statusId", 3, "title"], ["field", "vesselRevision.name", 3, "title"], ["field", "vesselRevision.iMONumber", 3, "title"], ["field", "ata", "format", "g", 3, "title"], ["field", "atd", "format", "g", 3, "title"], ["field", "eta", "format", "g", 3, "title"], ["field", "etd", "format", "g", 3, "title"], ["field", "portOfCallId", 3, "title"], ["field", "berthId", 3, "title"], ["field", "primaryAgent.name", 3, "title"], ["field", "primaryCallPurposeId", 3, "title"], ["field", "lastPortOfCallId", 3, "title"], ["field", "nextPortOfCallId", 3, "title"], ["field", "partiallyBilled", 3, "title"], ["field", "invoices", 3, "title", "sortable"], [1, "text-primary", "link-box", 3, "routerLink"], ["codelist", "Country", 3, "code", "tooltip", "floating", 4, "ngIf"], ["codelist", "Country", 3, "code", "tooltip", "floating"], [3, "code", "floating"], [3, "check", "hideFalse"], ["class", "text-primary link-box", "style", "cursor: pointer", 3, "click", 4, "ngIf"], [1, "text-primary", "link-box", 2, "cursor", "pointer", 3, "click"]],
  template: function VesselVisitListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0)(1, "app-content-header", 1);
      i0.ɵɵpipe(2, "translate");
      i0.ɵɵelementStart(3, "div", 2)(4, "ngb-accordion", 3)(5, "ngb-panel");
      i0.ɵɵtemplate(6, VesselVisitListComponent_ng_template_6_Template, 6, 5, "ng-template", 4);
      i0.ɵɵtemplate(7, VesselVisitListComponent_ng_template_7_Template, 75, 99, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(8, "kendo-tabstrip", 6, 7);
      i0.ɵɵlistener("tabSelect", function VesselVisitListComponent_Template_kendo_tabstrip_tabSelect_8_listener($event) {
        return ctx.tabSelected($event);
      });
      i0.ɵɵelementStart(10, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(11, "translate");
      i0.ɵɵtemplate(12, VesselVisitListComponent_ng_template_12_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(13, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(14, "translate");
      i0.ɵɵtemplate(15, VesselVisitListComponent_ng_template_15_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd()();
      i0.ɵɵtemplate(16, VesselVisitListComponent_ng_template_16_Template, 47, 61, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 7, "Vessel Visit List"));
      i0.ɵɵproperty("breadcrumb", ctx.breadcrumb);
      i0.ɵɵadvance(9);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(11, 9, "Vessel Visits"))("selected", ctx.activeTab === 0);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(14, 11, "Archived Vessel Visits"))("selected", ctx.activeTab === 1);
    }
  },
  dependencies: [i5.NgIf, i5.NgTemplateOutlet, i6.RouterLink, i7.NgControlStatus, i7.NgModel, i3.NgbAccordion, i3.NgbPanel, i3.NgbPanelContent, i3.NgbPanelHeader, i8.FaIconComponent, i9.ColumnComponent, i9.CheckboxColumnComponent, i9.CellTemplateDirective, i10.TabStripComponent, i10.TabStripTabComponent, i10.TabContentDirective, i11.ActionBarComponent, i12.AppControlComponent, i13.AppFormComponent, i14.ContentHeaderComponent, i15.AppGridComponent, i16.AppControlContainerComponent, i17.FlagIconComponent, i18.CheckIconComponent, i19.AccordionHeaderComponent, i5.AsyncPipe, i20.TranslatePipe, i21.CodelistPipe, i22.PadPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});